<template>
  <v-app>
    <v-app-bar app>
      <!-- Title -->
      <v-toolbar-title>Plan für {{ employeeName }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- Show Calendar-Icon when not on Startscreen -->
      <v-btn
        icon
        @click="changeView"
        v-if="bottomNav != 'start' && bottomNav != 'loading'"
      >
        <v-icon>mdi-calendar</v-icon>
      </v-btn>
    </v-app-bar>

    <!-- Sizes your content based upon application components -->
    <v-main style="padding: 0px; margin-top:0px">
      <!-- Show progress cycle on load -->
      <div class="text-center progress" v-if="bottomNav == 'loading'">
        <v-progress-circular
          :size="70"
          :width="7"
          color="blue"
          indeterminate
          center
        ></v-progress-circular>
      </div>

      <div v-if="bottomNav == 'start'">
        <div v-cloak>
          <!-- load Welcome Page content here from component -->
          <welcomepage
            :infoscreen="infoscreen"
            :key="'infoscreen'"
            @viewevent="setBottomNavView"
          ></welcomepage>
        </div>
      </div>

      <v-sheet height="64" v-if="bottomNav != 'start'">
        <v-toolbar flat color="white">
          <v-btn outlined class="mr-4" @click="setToday">Heute</v-btn>
          <v-btn fab text small @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
        </v-toolbar>
      </v-sheet>

      <!-- Provides the application the proper gutter -->
      <v-container fluid>
        <v-calendar
          v-if="bottomNav == 'me'"
          ref="persCalendar"
          :type="view"
          :now="today"
          locale="de"
          :weekdays="weekformat"
          :events="personalEvents"
          :event-color="getEventColor"
          v-model="navDate"
          @click:day="openDetailView"
          @click:date="openDetailView"
        ></v-calendar>

        <v-container style="margin-top: 0.7em" v-if="bottomNav == 'me'">
          <v-row no-gutters>
            <v-col cols="12" sm="3" offset-sm="9">
              <v-card outlined>
                <v-card-title> Legende </v-card-title>
                <v-chip class="ma-2" color="#B1DFFF" dark label small>
                  Früh
                </v-chip>
                <v-chip class="ma-2" color="#9FC9E6" dark label small>
                  Normal
                </v-chip>
                <v-chip class="ma-2" color="#6FA0C2" dark label small>
                  Spät
                </v-chip>
                <v-chip class="ma-2" color="#A6A6A6" dark label small>
                  Nacht
                </v-chip>
                <v-chip class="ma-2" color="#ff643c" dark label small>
                  Abweichungen
                </v-chip>
                <v-chip class="ma-2" color="#00c861" dark label small>
                  Frei
                </v-chip>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <div v-if="events.length > 0 && bottomNav == 'cal'">
          <shiftcalendar
            :eventcolor="getEventColor"
            :eventcolortext="getEventFontColor"
            :shiftplan="shiftplan"
            v-if="shiftplan"
            :view="view"
            :navDate="navDate"
            @dayselected="openDetailView"
          ></shiftcalendar>
        </div>

        <div
          v-if="events.length > 0 && bottomNav == 'team'"
          style="margin-top: 0px"
        >
          <teamcalendar
            :eventcolor="getEventColor"
            :eventcolortext="getEventFontColor"
            :shiftplan="shiftplan"
            v-if="shiftplan"
            :view="view"
            :navDate="navDate"
          ></teamcalendar>
        </div>
      </v-container>
    </v-main>

    <!-- Footer with navigation to proper gutter -->
    <v-footer app>
      <v-bottom-navigation v-model="bottomNav">
        <v-btn value="start" v-if="this.personalEvents.length > 0">
          <span>Start</span>
          <v-icon>mdi-home</v-icon>
        </v-btn>
        <v-btn value="me" v-if="this.personalEvents.length > 0">
          <span>Mein Plan</span>
          <v-icon>mdi-account</v-icon>
        </v-btn>

        <v-btn value="cal">
          <span>Kalender</span>
          <v-icon>mdi-calendar</v-icon>
        </v-btn>

        <v-btn value="team">
          <span>Team</span>
          <v-icon>mdi-account-group</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </v-footer>
  </v-app>
</template>

<style scoped>
.progress {
  margin: 2em;
}
[v-cloak] {
  display: none;
}
</style>

<script>
import axios from "axios";
import config from "../../configuration.json";
import welcomepage from "../components/Welcomepage";
import teamcalendar from "../components/TeamCalendar";
import shiftcalendar from "../components/ShiftCalendar";

export default {
  components: {
    welcomepage,
    teamcalendar,
    shiftcalendar,
  },
  data() {
    return {
      view: "month",
      teamView: "day",
      today: new Date().toISOString().substring(0, 10),
      navDate: new Date().toISOString().substring(0, 10),
      focusDate: new Date(),
      weekformat: [1, 2, 3, 4, 5, 6, 0],
      shiftplan: undefined,
      bottomNav: "loading",
      events: [],
      personalEvents: [],
      employeeid: undefined,
      subscribed: false,
      start: undefined,
      end: undefined,
      regularCapa: 13,
      employeeName: `${this.$store.getters.firstname} ${this.$store.getters.lastname}`,
      maxDays: 0,
      infoscreen: {
        today: {
          img: undefined,
          label: undefined,
          altShift: "",
        },
        nextDays: [
          {
            img: undefined,
            label: undefined,
            altShift: "",
          },
          {
            img: undefined,
            label: undefined,
            altShift: "",
          },
        ],
      },
    };
  },
  computed: {
    subscribeIcon: function () {
      return this.subscribed ? "mdi-bell-ring" : "mdi-bell-off";
    },
    src: function () {
      return `${config.fileUrl}/wfm/${this.$router.currentRoute.path.substring(
        1
      )}upload.json`;
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    // set today
    setToday: function () {
      this.navDate = new Date().toISOString().substring(0, 10);
    },
    // set proper previous value (either day, week or month)
    prev: function () {
      if (this.bottomNav == "team") {
        let date = new Date(this.navDate);
        date.setDate(date.getDate() - 1);
        this.navDate = date.toISOString().substring(0, 10);
      } else if (this.view == "week") {
        let date = new Date(this.navDate);
        date.setDate(date.getDate() - 7);
        this.navDate = date.toISOString().substring(0, 10);
      } else if (this.view == "month") {
        let date = new Date(this.navDate);
        date.setMonth(date.getMonth() - 1);
        this.navDate = date.toISOString().substring(0, 10);
      }
    },
    // set proper next value (either day, week or month)
    next() {
      if (this.bottomNav == "team") {
        let date = new Date(this.navDate);
        date.setDate(date.getDate() + 1);
        this.navDate = date.toISOString().substring(0, 10);
      } else if (this.view == "week") {
        let date = new Date(this.navDate);
        date.setDate(date.getDate() + 7);
        this.navDate = date.toISOString().substring(0, 10);
      } else if (this.view == "month") {
        let date = new Date(this.navDate);
        date.setMonth(date.getMonth() + 1);
        this.navDate = date.toISOString().substring(0, 10);
      }
    },
    subscribeEvents: function () {
      this.subscribed = !this.subscribed;
    },
    // load data from endpoint
    loadData: async function () {
      let self = this;

      this.employeeid = this.$store.getters.employeeid;

      /***
       * DEBUG OPTION FOR DEVELOPERS AND TESTERS
       *
       * 558120 - Employee ID Tino Friedemann
       * 557110 - Employee ID Tamina Rech
       *
       ****/

      // for testing and development assign testuser to testers and developers
      /*if (this.employeeid == 558120 || this.employeeid == 557110) {
        this.employeeid = 500448;
      }*/

      //get correct shiftplan as json
      axios.get(this.src).then((response) => {
        self.shiftplan = response.data;

        // iterate over shiftplan
        for (let i = 0; i < self.shiftplan.length; i++) {
          //scroll to the current month
          self.focusDate.setDate(1);
          self.focusDate.setMonth(parseInt(self.shiftplan[i].month) - 1);
          self.focusDate.setYear(parseInt(self.shiftplan[i].year));

          // eslint-disable-next-line no-console
          console.log(self.focusDate);

          //get the last day of the month e.g. 31 in December
          let copyDate = new Date(self.focusDate.getTime());
          copyDate.setMonth(copyDate.getMonth() + 1);
          copyDate.setDate(0);
          self.maxDays = copyDate.getDate();

          //load all shiftplans
          self.parseShiftEvents(self.shiftplan[i]);
          self.parsePersonalEvents(self.shiftplan[i]);
        }

        // check for personal events in shiftplan and assign correct view
        if (this.personalEvents.length == 0) {
          this.bottomNav = "cal";
        } else {
          this.bottomNav = "start";
        }
      });
    },
    //change view with calendar icon in navbar
    changeView: function () {
      // in other views than teamview, show current month and on switch current week
      if (this.view == "month") {
        this.view = "week";
      } else {
        this.view = "month";
      }
    },
    // get correct time labels for shift by shortcut
    getTimeLabels: function (key) {
      if (key != undefined && key != "") {
        switch (key.toLowerCase()) {
          case "g":
            return "Frei";
          case "":
            return "Frei";
          case "f":
            return "Früh";
          case "s":
            return "Spät";
          case "n":
            return "Nacht";
          case "r":
            return "Normal";
          case "aw":
            return "Abwesend";
          case "sem":
            return "Seminar";
          case "ku":
            return "Kurzarbeit";
          case "tu":
            return "Urlaub";
          case "gz":
            return "Gleitzeit";
          case "tz":
            return "frei wg. Teilzeit";
          case "kr":
            return "Krank";
          case "kk":
            return "Kurzarb. Krank";
          case "uu":
            return "Jokertage";
          case "az":
            return "Altersfreizeit";
          default:
            return key;
        }
      }
      return key;
    },
    openDetailView(event) {
      this.navDate = event.date;
      this.bottomNav = "team";
    },
    // get correct info label and images for shift by shortcut
    getInfoBoxContent: function (key) {
      if (key != undefined && key != "") {
        switch (key.toLowerCase()) {
          case "g":
          case "":
            return { img: "img/shift/f.jpg", label: "Sie haben frei" };
          case "f":
            return {
              img: "img/shift/fr.jpg",
              label: "Sie arbeiten in der Frühschicht",
            };
          case "s":
            return {
              img: "img/shift/lh_sp.jpg",
              label: "Sie arbeiten in der Spätschicht",
            };
          case "n":
            return {
              img: "img/shift/lh_na.jpg",
              label: "Sie arbeiten in der Nachtschicht",
            };
          case "r":
            return {
              img: "img/shift/lh_ta.jpg",
              label: "Sie arbeiten in der Normalschicht",
            };
          case "af":
            return {
              img: "img/shift/fr.jpg",
              label: "Sie arbeiten abweichend in der Frühschicht",
            };
          case "as":
            return {
              img: "img/shift/lh_sp.jpg",
              label: "Sie arbeiten abweichend in der Spätschicht",
            };
          case "ar":
            return {
              img: "img/shift/lh_ta.jpg",
              label: "Sie arbeiten abweichend in der Normalschicht",
            };
          case "an":
            return {
              img: "img/shift/lh_na.jpg",
              label: "Sie arbeiten abweichend in der Nachtschicht",
            };
          case "aw":
            return {
              img: "img/shift/g.jpg",
              label: "Sie sind abwesend",
            };
          case "sem":
            return {
              img: "img/shift/g.jpg",
              label: "Sie sind auf einem Seminar",
            };
          default:
            return {
              img: "img/shift/s.jpg",
              label: `Sie haben ${this.getTimeLabels(key)}`,
            };
        }
      }
      return { img: "img/shift/c11.jpg", label: "Abweichender Eintrag" };
    },
    // get shiftplan by day
    getShiftPlanByDay: function (shiftplan, shiftId, day) {
      for (let i = 0; i < shiftplan.shifts.length; i++) {
        let shift = shiftplan.shifts[i];
        let shiftShort = shift.name.trim().toUpperCase();
        if (shiftShort == shiftId.trim()) {
          return shiftId + " - " + this.getTimeLabels(shift.plan[day]);
        }
      }
      return "X";
    },
    // get shift id by day
    getShiftIdByDay: function (shiftplan, shiftId, day) {
      for (let i = 0; i < shiftplan.shifts.length; i++) {
        let shift = shiftplan.shifts[i];
        let shiftShort = shift.name.trim().toUpperCase();
        if (shiftShort == shiftId.trim()) {
          return shift.plan[day];
        }
      }
      return "X";
    },
    // parse personal events
    parsePersonalEvents: function (shiftplan) {
      for (let i = 0; i < shiftplan.shifts.length; i++) {
        let shift = shiftplan.shifts[i];

        if (shift.name == "") {
          shift.name = "Unbekannt";
        }

        // iterate over workplaces
        for (let k = 0; k < shift.workplaces.length; k++) {
          let workplace = shift.workplaces[k];
          let tempPlan = undefined;
          // iterate over workers
          for (let l = 0; l < workplace.worker.length; l++) {
            //check employee id
            if (workplace.worker[l].employeeId == this.employeeid) {
              for (let j = 0; j < shift.plan.length && j < this.maxDays; j++) {
                if (shift.name == undefined) {
                  break;
                }
                //this.employeeName = workplace.worker[l].name;
                let date = new Date(this.focusDate.getTime());
                date.setDate(j + 1);

                let today = new Date();
                let tommorrow = new Date();
                tommorrow.setDate(today.getDate() + 1);
                let in2Days = new Date();
                in2Days.setDate(today.getDate() + 2);

                if (date.getDate() == today.getDate() && parseInt(shiftplan.month) == today.getMonth() +1 && parseInt(shiftplan.year) == today.getFullYear()) {
                  this.infoscreen.today = this.getInfoBoxContent(shift.plan[j]);
                }
                else if (date.getDate() == tommorrow.getDate() && parseInt(shiftplan.month) == tommorrow.getMonth() +1 && parseInt(shiftplan.year) == tommorrow.getFullYear()) {
                  this.infoscreen.nextDays[0] = this.getInfoBoxContent(shift.plan[j]);
                }
                else if (date.getDate() == in2Days.getDate() && parseInt(shiftplan.month) == in2Days.getMonth() +1 && parseInt(shiftplan.year) == in2Days.getFullYear()) {
                  this.infoscreen.nextDays[1] = this.getInfoBoxContent(shift.plan[j]);
                }
                

                // check if temporary plan exists
                if (
                  tempPlan != undefined &&
                  tempPlan.name ==
                    shift.name + "- " + this.getTimeLabels(shift.plan[j])
                ) {
                  tempPlan.end = date.toISOString().substring(0, 10);
                }
                // create temporary plan if it does not exist
                else {
                  if (tempPlan != undefined) {
                    this.personalEvents.push(tempPlan);
                    tempPlan = undefined;
                  }

                  // generate temporary plan with correct values
                  tempPlan = {
                    name: shift.name + "- " + this.getTimeLabels(shift.plan[j]),
                    start: date.toISOString().substring(0, 10),
                    end: date.toISOString().substring(0, 10),
                    color: "#005ABB",
                  };

                  //add correct shift color to temporary plan
                  switch (shift.plan[j].toUpperCase()) {
                    case "F":
                      tempPlan.color = "#B1DFFF";
                      break;
                    case "R":
                      tempPlan.color = "#9FC9E6";
                      break;
                    case "S":
                      tempPlan.color = "#6FA0C2";
                      break;
                    case "N":
                      tempPlan.color = "#A6A6A6";
                      break;
                    case "G":
                    case "":
                      tempPlan.color = "#00c861";
                      break;
                  }

                  // push temporary plan to personal events
                  if (
                    workplace.worker[l].notes[j] == "" ||
                    workplace.worker[l].notes[j] == undefined
                  ) {
                    this.personalEvents.push(tempPlan);
                  }

                  tempPlan = undefined;
                }
              }
              // check if temporary plan is not filled after loop
              if (tempPlan != undefined) {
                this.personalEvents.push(tempPlan);
              }
              // iterate over workplace worker notes
              for (
                let m = 0;
                m < workplace.worker[l].notes.length && m < this.maxDays;
                m++
              ) {
                let note = workplace.worker[l].notes[m].trim();
                let altShift = workplace.worker[l].altShifts[m].trim();

                if (note != "" && note.toUpperCase() != "G") {
                  let date = new Date(this.focusDate.getTime());
                  date.setDate(m + 1);

                  let label = this.getTimeLabels(note);
                  // check date and compare with today and next two days
                  if (
                    date.getDate() >= new Date().getDate() &&
                    date.getDate() <= new Date().getDate() + 2 &&
                    parseInt(shiftplan.month) == new Date().getMonth() +1
                  ) {
                    let shiftByNote = note;

                    // check if note in shift matches shift shortcuts
                    if (
                      note.toUpperCase() == "A" ||
                      note.toUpperCase() == "B" ||
                      note.toUpperCase() == "C" ||
                      note.toUpperCase() == "D" ||
                      note.toUpperCase() == "E"
                    ) {
                      shiftByNote =
                        "a" + this.getShiftIdByDay(shiftplan, label, m);
                    }

                    let today = new Date();
                    let tommorrow = new Date();
                    tommorrow.setDate(today.getDate() + 1);
                    let in2Days = new Date();
                    in2Days.setDate(today.getDate() + 2);

                    if (date.getDate() == today.getDate() && parseInt(shiftplan.month) == today.getMonth() +1 && parseInt(shiftplan.year) == today.getFullYear()) {
                      // eslint-disable-next-line no-console
                      console.log("shift alt " + shiftByNote + " - " + altShift);
                      this.infoscreen.today = this.getInfoBoxContent(shiftByNote);
                      this.infoscreen.today["comment"] = altShift;
                    }
                    else if (date.getDate() == tommorrow.getDate() && parseInt(shiftplan.month) == tommorrow.getMonth() +1 && parseInt(shiftplan.year) == tommorrow.getFullYear()) {
                      this.infoscreen.nextDays[0] = this.getInfoBoxContent(shiftByNote);
                      this.infoscreen.nextDays[0]["comment"] = altShift
                    }
                    else if (date.getDate() == in2Days.getDate() && parseInt(shiftplan.month) == in2Days.getMonth() +1 && parseInt(shiftplan.year) == in2Days.getFullYear()) {
                      this.infoscreen.nextDays[1] = this.getInfoBoxContent(shiftByNote);
                      this.infoscreen.nextDays[1]["comment"] = altShift
                    }    
                  }
                  // check for label and assign to shift plan by day if match
                  if (label.length == 1) {
                    label = this.getShiftPlanByDay(shiftplan, label, m);
                  }

                  // generate temporary plan for shift plan by day
                  tempPlan = {
                    name: label,
                    start: date.toISOString().substring(0, 10),
                    end: date.toISOString().substring(0, 10),
                    color: "#ff643c",
                  };
                  this.personalEvents.push(tempPlan);

                  if (altShift != "") {
                    let tempPlanShift = {
                      name: altShift,
                      start: date.toISOString().substring(0, 10),
                      end: date.toISOString().substring(0, 10),
                      color: "#CCCCCC",
                    };

                    this.personalEvents.push(tempPlanShift);
                  }
                }
              }
            }
          }
        }
      }
    },
    // parse events in shift
    parseShiftEvents: function (shiftplan) {
      let cal_color = [
        "#0050ff",
        "#6FA0C2",
        "#ff643c",
        "#00c861",
        "#A6A6A6",
        "#000",
        "black",
        "pink",
      ];
      let timeframe = ["F", "R", "S", "N"];

      // iterate over timeframe of this shift
      for (let x = 0; x < timeframe.length; x++) {
        for (let i = 0; i < shiftplan.shifts.length; i++) {
          let shift = shiftplan.shifts[i];
          var tempPlan = undefined;

          for (
            let j = 0;
            j < shift.plan.length &&
            shift.plan[j] != undefined &&
            j < this.maxDays;
            j++
          ) {
            //if shift name is empty, stop here
            if (shift.name == undefined) {
              break;
            }

            // if temporary plan is empty, set its enddate to today
            let date = new Date(this.focusDate.getTime());
            date.setDate(j + 1);

            if (
              tempPlan != undefined &&
              tempPlan.name ==
                shift.name + "- " + this.getTimeLabels(shift.plan[j])
            ) {
              tempPlan.end = date.toISOString().substring(0, 10);
            } else {
              // push tempPlan to events and reset tempPlan after push
              if (tempPlan != undefined) {
                this.events.push(tempPlan);
                tempPlan = undefined;
              }

              // check if shift plan shortcut matched timeframe and then change tempPlan
              if (shift.plan[j].toUpperCase() == timeframe[x]) {
                tempPlan = {
                  name: shift.name + "-" + this.getTimeLabels(shift.plan[j]),
                  start: date.toISOString().substring(0, 10),
                  end: date.toISOString().substring(0, 10),
                  color: cal_color[i],
                };

                // push tempPlan to events and reset tempPlan after push
                this.events.push(tempPlan);
                tempPlan = undefined;
              }
            }
          }
        }
        // push tempPlan to events //correct, that here is no reset?
        if (tempPlan != undefined) {
          this.events.push(tempPlan);
        }
      }
    },
    // get proper color for event
    getEventColor(event) {
      return event.color;
    },
    // get proper font color for event
    getEventFontColor(event) {
      if (event.fontcolor != undefined) {
        return event.fontcolor;
      } else {
        return "#fff";
      }
    },
    // set current view
    setBottomNavView(bottomNavVar) {
      this.bottomNav = bottomNavVar;
    },
  },
};
</script>
